<ngx-spinner
    bdColor = "rgba(0,0,0,0.6)"
    size = "medium"
    color = "#fff"
    type = "ball-atom"
    [fullScreen] = "true"
>
    <p style="color: white" > Cargando, por favor espere. </p>
</ngx-spinner>

<router-outlet />
